import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useClinicTheme } from "../../theme";
import { COLORS } from "../../styles/uiConstants";
import { resolveLogo } from "../../utils/clinicLogo";

/**
 * Liste satırlarında klinik gösterimi: logo (yoksa baş harf rozeti) + klinik adı.
 * `onClick` verilirse satır tıklanabilir olur (klinik detayına gitmek için).
 * Klinik yoksa tire gösterir — logo alanı da boş kalır.
 */
export default function ClinicLabel({ clinic, onClick, size = 26, sx = {} }) {
  const { palette } = useClinicTheme();

  if (!clinic?.name) {
    return (
      <Typography sx={{ fontSize: "0.8125rem", color: COLORS.slate400 }} noWrap>
        —
      </Typography>
    );
  }

  const logo = resolveLogo(clinic.logoIconUrl || clinic.logoUrl);
  const color = clinic.themeColor || palette.primary;

  const avatar = logo ? (
    <Avatar
      src={logo}
      alt={clinic.name}
      variant="rounded"
      sx={{ width: size, height: size, flexShrink: 0, bgcolor: COLORS.white }}
    />
  ) : (
    <Avatar
      variant="rounded"
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        fontSize: size * 0.42,
        fontWeight: 700,
        bgcolor: alpha(color, 0.12),
        color,
      }}
    >
      {clinic.name[0].toUpperCase()}
    </Avatar>
  );

  const label = (
    <Typography
      className="clinicLabelName"
      component="span"
      sx={{ fontSize: "0.8125rem", color: "inherit", minWidth: 0 }}
      noWrap
    >
      {clinic.name}
    </Typography>
  );

  if (!onClick) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, color: COLORS.slate700, ...sx }}>
        {avatar}
        {label}
      </Box>
    );
  }

  return (
    <Box
      component="button"
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick(clinic);
      }}
      aria-label={`${clinic.name} detayına git`}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        maxWidth: "100%",
        minWidth: 0,
        bgcolor: "transparent",
        border: "none",
        padding: 0,
        margin: 0,
        cursor: "pointer",
        textAlign: "left",
        font: "inherit",
        color: palette.primary,
        "&:hover .clinicLabelName": { textDecoration: "underline" },
        "&:focus-visible": {
          outline: `2px solid ${alpha(palette.primary, 0.5)}`,
          outlineOffset: 2,
        },
        ...sx,
      }}
    >
      {avatar}
      {label}
    </Box>
  );
}
